import { combineReducers } from "redux";
import tenure from "./TenureReducer";
import interest from "./InterestReducer";
import product from "./ProductReducer";
import orderStatus from "./OrderStatusReducer";
export default combineReducers({ tenure: tenure, interest: interest, product: product, orderStatus: orderStatus });
